import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { useParams } from 'react-router-dom'
import HtmlWithDefaultStyles from '../../../components/DangerousHtml/HtmlWithDefaultStyles'
import Loader from '../../../components/Loader/Loader'
import { useVacancyDetailsQuery } from '../../../helpers/vacancyApi'
import StatisticsForm from '../../Home/StatisticsForm'

const options = {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
};


const VacancyDetails = () => {

    const { slug } = useParams()

    const [day, setday] = useState('')
    const [month, setmonth] = useState('')
    const [year, setyear] = useState('')

    const { data, isFetching } = useVacancyDetailsQuery(slug)

    useEffect(() => {
        if (data) {
            const formattedDate = new Date(data.vacancy[0].ExpiryDate).toLocaleDateString('en-US', options);
            const [month, day, year] = formattedDate.split(' ');
            setmonth(month)
            setday(day)
            setyear(year)
        }
    }, [data])

    return (
        <div>
            <div className="dark:bg-gray-900 transition-all duration-700 min-h-[90vh]">
                <div className=' pt-[45px] md:pt-[62px]'>
                    {isFetching ? <Loader text={'Loading details...'} height='80vh' /> : (
                        <div>
                            <Helmet >
                                <title> CodeZone | Vacancy | {data.vacancy[0].slug}</title>
                            </Helmet>
                            <div className='max-w-screen-xl px-4 py-8 md:py-10 mx-auto'>
                                <div className='grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-9'>
                                    <div>
                                        <h1 className='text-center md:text-left md:text-2xl font-bold dark:text-white'>
                                            {data.vacancy[0].title}
                                        </h1>
                                        <div className='flex flex-col sm:flex-row sm:divide-x-2 gap-1 sm:gap-2 divide-black dark:divide-white dark:divide text-gray-400 text-xs md:text-sm font-bold my-2 dark:text-white'>
                                            <h1 className='text-center sm:text-left'>
                                                Apply Before {month} {day} {year}
                                            </h1>
                                            <h1 className='sm:pl-2 text-center sm:text-left'>
                                                Total positions: {data.vacancy[0].position}
                                            </h1>
                                        </div>
                                        <HtmlWithDefaultStyles htmlString={data.vacancy[0].desc} />
                                    </div>
                                    <div>
                                        <StatisticsForm vacancy={true} slugAdmin={data.vacancy[0].slugAdmin}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default VacancyDetails


